import { useEffect } from "react";

// Applied to standalone admin auth pages (forgot/reset password): keep them out of
// search indexes, out of caches, and stop the URL (which may carry a token) leaking
// via the Referer header. The tags are removed again when the page unmounts.
export const useSecurityMeta = () => {
  useEffect(() => {
    const added = [];
    const specs = [
      ["name", "referrer", "no-referrer"],
      ["name", "robots", "noindex, nofollow"],
      ["http-equiv", "Cache-Control", "no-store"],
      ["http-equiv", "Pragma", "no-cache"],
    ];
    for (const [attr, key, content] of specs) {
      const m = document.createElement("meta");
      m.setAttribute(attr, key);
      m.content = content;
      m.setAttribute("data-security-meta", "1");
      document.head.appendChild(m);
      added.push(m);
    }
    return () => added.forEach((m) => m.remove());
  }, []);
};
